import { ComputedRef } from 'vue'

import { CategoryRating } from '@/domain/entities/dashboard/categoryRating'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { CategoryRatingViewModel } from '@/presentation/viewmodels/dashboard/categoryRatingViewModel'

export class CategoryRatingPresenter {
  private viewModel: CategoryRatingViewModel

  constructor(viewModel: CategoryRatingViewModel) {
    this.viewModel = viewModel
  }

  get userWhatCategoryRatingList(): ComputedRef<CategoryRating[][]> {
    return this.viewModel.userWhatCategoryRatingList
  }

  get userHowCategoryRatingList(): ComputedRef<CategoryRating[][]> {
    return this.viewModel.userHowCategoryRatingList
  }

  get userProgrammingCategoryRatingList(): ComputedRef<CategoryRating[][]> {
    return this.viewModel.userProgrammingCategoryRatingList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async addUserCategoryRating(userId: string): Promise<void> {
    await this.viewModel.addUserCategoryRating(userId)
  }

  async addUserCategoryRatingByLanguage(userId: string, programLanguage: ProgramLanguageType | 'All'): Promise<void> {
    await this.viewModel.addUserCategoryRatingByLanguage(userId, programLanguage)
  }

  removeUserCategories(): void {
    this.viewModel.removeUserCategories()
  }

  removeTargetUsers(): void {
    this.viewModel.removeTargetUsers()
  }
}
